/* RESPONSIBLE TEAM: team-proactive-support */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class Action extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    ruleset: { embedded: 'always' },
  };

  // Override serialize to handle segment changes
  serialize(snapshot: any, options?: any): any {
    let json = super.serialize(snapshot, options);
    let record = snapshot.record;

    if (!record.appService?.app?.canUseFeature?.('tdf-migrate-actions-to-fin-audience')) {
      return json;
    }

    if (record.hasAudienceChanges) {
      let payload = record.getAudienceChangePayload();
      json.segment_ids_to_add = payload.segmentIdsToAdd;
      json.segment_ids_to_delete = payload.segmentIdsToDelete;
    }

    // Remove client-side field from API payload
    delete json.ai_content_segment_ids;
    delete json.aiContentSegmentIds;

    // Only send ruleset for custom mode
    if (record.audienceMode !== 'custom') {
      delete json.ruleset;
    }

    return json;
  }

  // @ts-ignore
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (requestType === 'findRecord') {
      this.formatMockResponseBody(payload);
    } else if (requestType === 'findAll') {
      payload.forEach((object: any) => this.formatMockResponseBody(object));
    }

    // @ts-ignore
    return super.normalizeResponse(...arguments);
  }

  private formatMockResponseBody(json: any) {
    let body = json.mock_response?.body;
    if (body !== undefined) {
      try {
        let parsedBody = JSON.parse(json.mock_response.body);
        json.mock_response.body = JSON.stringify(parsedBody, null, 4);
      } catch (e) {
        // leave the contents of mock_response.body unchanged
      }
    }
  }
}
